const localeConfig: {[key: string]: string} = {
    "fr-FR": "fr_FR",
    "en-US": "en_US",
    "nl-NL": "nl_NL",
    "fr-FR-CSE": "fr_FR_CSE"
}


export const companyLangToLocale: Map<string, string> = new Map([
    ["nl", "nl-NL"]
])

export default localeConfig